<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("cookie.menu.data") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <div class="space-y-2">
                    <p class="text-sm font-medium ct-text-2">
                        {{ $t("cookie.data.consent_list") }}
                    </p>

                    <p class="ct-text">
                        {{ $t("cookie.data.consent_list_info") }}
                    </p>
                </div>

                <FormToggleSm
                    :modelValue="cookie.listWithConsents"
                    @update:modelValue="createListOfConsents"
                    :title="$t('cookie.data.create_list')"
                />

                <a v-if="cookie.listWithConsents" :href="downloadListLink" download class="block">
                    <ButtonSecondarySm class="w-full">
                        {{ $t("cookie.data.download_list") }}
                    </ButtonSecondarySm>
                </a>

                <template v-if="cookie.listWithConsents && cookie.listUrl">
                    <FormInputPostButton
                        :title="$t('cookie.data.old_list')"
                        disabled
                        v-model="cookie.listUrl"
                        :ctaLabel="$t('shared.copy')"
                        ctaIcon="CopyDocumentIcon"
                        @cta="copyThis(cookie.listUrl)"
                    />
                </template>

                <FormDivider />

                <div class="space-y-2">
                    <p class="text-sm font-medium ct-text-2">
                        {{ $t("cookie.data.revoke") }}
                    </p>

                    <p class="ct-text">
                        {{ $t("cookie.data.revoke_info") }}
                    </p>
                </div>

                <FormInputPostButton
                    disabled
                    v-model="revokeFullLink"
                    :ctaLabel="$t('shared.copy')"
                    ctaIcon="CopyDocumentIcon"
                    @cta="copyThis(revokeFullLink)"
                />

                <p class="ct-text">
                    {{ $t("cookie.data.revoke_help") }}
                    <strong>data-ec-revoke</strong>
                </p>

                <FormDivider />

                <div class="space-y-2">
                    <p class="text-sm font-medium ct-text-2">
                        {{ $t("cookie.data.change") }}
                    </p>

                    <p class="ct-text">
                        {{ $t("cookie.data.change_info") }}
                    </p>
                </div>

                <FormInputPostButton
                    disabled
                    v-model="changeFullLink"
                    :ctaLabel="$t('shared.copy')"
                    ctaIcon="CopyDocumentIcon"
                    @cta="copyThis(changeFullLink)"
                />

                <p class="ct-text">
                    {{ $t("cookie.data.revoke_help") }}
                    <strong>data-ec-change</strong>
                </p>

                <FormDivider />

                <div class="space-y-2">
                    <p class="text-sm font-medium ct-text-2">
                        {{ $t("cookie.data.gtm") }}
                    </p>

                    <p class="ct-text">
                        {{ $t("cookie.data.gtm_info") }}
                    </p>
                </div>

                <FormToggleSm v-model="cookie.sendToGtm" :title="$t('cookie.data.gtm_send')" />

                <FormDivider />

                <div class="space-y-2">
                    <p class="text-sm font-medium ct-text-2">
                        {{ $t("cookie.data.webhooks") }}
                    </p>

                    <p class="ct-text">
                        {{ $t("cookie.data.webhooks_info") }}
                    </p>
                </div>

                <FormInput
                    :title="$t('cookie.data.webhook_url')"
                    v-model="cookie.webhookUrl"
                    :placeholder="`${$t('shared.eg')} https://hooks.zapier.com/yourhook`"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { mapState, mapMutations, mapActions } from "vuex";
import { ButtonSecondarySm } from "@easy/ui/buttons";
import { FormToggleSm, FormInputPostButton, FormDivider, FormInput } from "@easy/ui/forms";
import { copy } from "@/shared/utils/string";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    name: "SidebarData",
    components: {
        PageSidebar,
        FormToggleSm,
        FormInputPostButton,
        ButtonSecondarySm,
        FormDivider,
        FormInput,
        cSaveButton,
    },
    computed: {
        ...mapState(["globalUrl"]),
        ...mapState("cookie", ["cookie", "hasChanges"]),
        revokeFullLink() {
            return `<a data-ec-revoke href="">${this.revokeText}</a>`;
        },
        downloadListLink() {
            return `${this.globalUrl}/api/cookies/${this.cookie.uuid}/consents`;
        },
        changeFullLink() {
            return `<a data-ec-change href="">${this.changeText}</a>`;
        },
        changeText() {
            return this.$t("cookie.data.change_link");
        },
        revokeText() {
            return this.$t("cookie.data.revoke_link");
        },
    },

    methods: {
        ...mapMutations(["showAlert"]),
        ...mapActions("cookie", ["saveSnapshot", "createListOfConsents"]),
        copyThis(text) {
            copy(text);
            this.showAlert({
                type: "success",
                title: this.$t("shared.copied"),
            });
        },
    },
};
</script>
